var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column col items-center full-width"},[(!_vm.hydrationComplete)?_c('SAIPageSpinner'):_vm._e(),(_vm.hydrationComplete)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }